import React from "react";
import PageHeader from "@/components/PageHeader";
import About from "@/components/About";
import WhyChooseUs from "@/components/WhyChooseUs";
import CTABanner from "@/components/CTABanner";

export default function AboutPage() {
  return (
    <div data-testid="page-about">
      <PageHeader title="About" />
      <About />
      <WhyChooseUs />
      <CTABanner />
    </div>
  );
}
